// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { isPrerender } from "../utils/isPrerender";
import {
  getAnalytics,
  logEvent,
  setUserId,
  setUserProperties,
} from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

console.log("firebaseConfig:", firebaseConfig);
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = isPrerender ? null : getAnalytics(app);

// /**
//  * Log a website visit event to Firebase Analytics
//  */
const logWebsiteVisit = () => {
  if (!analytics) return;
  logEvent(analytics, "website_visit", {
    timestamp: new Date().toISOString(),
  });
};

// /**
//  * Log a page view event to Firebase Analytics
//  * @param pageName The name of the page being viewed
//  */
// const logPageView = (pageName: string) => {
//   logEvent(analytics, 'page_view', {
//     page_name: pageName,
//     timestamp: new Date().toISOString(),
//   });
// };

/**
 * Set a user ID for analytics (use with authenticated users)
 * @param uid User ID to associate with events
 */
// const setAnalyticsUserId = (uid: string) => {
//   setUserId(analytics, uid);
// };

export { app, analytics, logWebsiteVisit };

